module.exports = __webpack_public_path__ + "front/img/64.5e6893e2.png";